<template>
  <div class="container room_pay">
    <div class="list_contener">
      <!--会议室信息  -->
      <div class="list_box border-bottom">
        <img class="center_left_box" :src="metingRoom.meetingRoomImages" />
        <div class="center_right_box">
          <div class="centerRightTop">
            <p class="center_right_title">{{metingRoom.meetingRoomName}}</p>
            <p class="center_right_address over_two_lines">{{metingRoom.address}}</p>
          </div>
          <span class="center_right_area">面积{{metingRoom.area}}㎡ 座位{{metingRoom.meetingRoomNum}}人</span>
        </div>
      </div>
      <div class="userInfo">
        <p class="left_text">预订人: {{userName}}</p>
        <p class="phoneText">手机号: {{tel}}</p>
      </div>
      <!-- 用户支付信息 -->
      <div class="userInfo_List">
        <div class="userInfo_item border-bottom">
          <div class="item_left">
            <span class="left_text">总计时段</span>
            <span
              class="timeInterval"
            >{{day}} {{selectDay}} {{activeWeekDay}} {{timeList[selectStart].time}}-{{timeList[selectEnd].time}}</span>
          </div>
          <span class="right_text">{{hour}}小时</span>
        </div>
        <div class="userInfo_item border-bottom" @click="showCouponAction" v-if="!orderNo">
          <span class="left_text">优惠券</span>
          <div class="item_right" v-if="activeAmountDiscount === 0">
            <span class="none" v-if="listsLength === 0">无可用</span>
            <span class="amount" v-else>{{listsLength}}张可用</span>
            <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
          </div>
          <div class="item_right" v-if="activeAmountDiscount != 0">
            <span
              class="msgNum"
              v-if="activeDiscountMode == '1'"
            >-¥{{activeAmountDiscount.toFixed(2)}}</span>
            <span class="msgNum" v-else>{{activeAmountDiscount/10}}折</span>
            <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
          </div>
        </div>
        <div class="userInfo_item border-bottom" v-if="!orderNo">
          <div class="item_integral_left">
            <span class="left_text">积分</span>
            <div class="integral_info left_text">
              <span class="timeInterval" v-if="userIntegralInfo.status == 1">积分已冻结</span>
              <span class="timeInterval" v-if="integralDeductRule.id && userIntegralInfo.status != 1">{{integralDeductRule.integration}}积分/元,当前积分{{userIntegralInfo.memberIntegration || 0}}</span>
            </div>
          </div>
          <div class="item_integral_right">
            <span class="deduct_money" v-if="userDeductInfo.deductMoney > 0 ">可抵扣{{userDeductInfo.deductMoney}}元</span>
            <span class="timeInterval" v-if="!userIntegralInfo.id || !integralDeductRule.id || userIntegralInfo.memberIntegration == 0 ||  userIntegralInfo.status == 1">无可用</span>
            <div style="margin-left:8px">
               <div v-if="integralOptions[0].disabled" style="background:#eee" class="noneCouponBtn"></div>
               <div @click="activeIntegral" style="width:40px;" v-if="!isSelectIntegral && !integralOptions[0].disabled">
                  <div style="border:1px solid  rgb(204, 204, 204);" class="noneCouponBtn"></div>
               </div>
               <div @click="activeIntegral" style="width:40px;" v-if="isSelectIntegral && !integralOptions[0].disabled"> 
                  <img class="CouponBtn"  src="../../assets/images/icon_coupon_selected.png" />
               </div>
            </div>
          </div>
        </div>
        <template v-if="chargeList.length !== 0 && !orderNo">
          <div class="userInfo_item">
            <p class="left_text">付费服务</p>
          </div>
          <div class="chargeBox">
            <div
              v-for="(item,index) in chargeList"
              @click="changeCharge(index)"
              :key="index"
              :class="['chargeCard',item.isDrop ? 'activeChargeCard' : '']"
            >
              <span :class="[item.isDrop ? 'activeChargeText' : 'chargeText']">{{item.chargeName}}</span>
              <span
                :class="[item.isDrop ? 'activeChargeText' : 'chargeText']"
              >¥{{item.chargePrice.toFixed(2)}}</span>
              <img v-if="item.isDrop" class="activeIcon" src="../../assets/images/selected.png" />
            </div>
          </div>
        </template>
      </div>
      <div class="sumBox">
        <div class="priceBox">
          <span class="left_text">商品金额</span>
          <span class="right_text">¥{{totalPrice.toFixed(2)}}</span>
        </div>
        <div class="priceBox" v-if="freePrice">
          <span class="left_text">免费额度</span>
          <span class="msgNum">-¥{{Number(freePrice).toFixed(2)}}</span>
        </div>
        <div class="priceBox" v-if="bondItemId">
          <span class="left_text">优惠券</span>
          <span
            class="msgNum"
            v-if="activeDiscountMode == '1'"
          >-¥{{activeAmountDiscount.toFixed(2)}}</span>
          <span class="msgNum" v-else>-¥{{bondItemAmount.toFixed(2)}}</span>
        </div>
        <div class="priceBox" v-if="chargePrice > 0">
          <span class="left_text">付费服务</span>
          <span class="msgNum">+¥{{chargePrice.toFixed(2)}}</span>
        </div>
          <div class="priceBox" v-if="userDeductInfo.deductMoney > 0">
          <span class="left_text">积分抵扣</span>
          <span class="timeInterval" style="flex:1">使用{{userDeductInfo.integral}}积分,积分余额为{{userIntegralInfo.memberIntegration-userDeductInfo.integral}}</span>
          <span class="msgNum">-¥{{userDeductInfo.deductMoney.toFixed(2)}}</span>
        </div>
      </div>
      <div class="room_AgreementCard" v-if="meetingAgreementList &&meetingAgreementList.length>0" >
         <p class="room_introduce_title_text">协议模板</p>
          <div class="room_Agreement_box" v-for="(item,index) in  meetingAgreementList" :key="index">
            <div class="room_Agreement_box1" @click="openFile(item.path,item.agreementName)">
               <img class="room_Agreement_icon" src="../../assets/images/icon_file.png" />
               <span class="room_Agreement_span" >{{item.agreementName}}</span>
               <img class="room_Agreement_icon1" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="room_Agreement_line"></div>

          </div>
      </div>
    </div>
    <div class="submit_bottom">
      <div class="submitLeft">
        <span class="submitSumText">合计:</span>
        <span class="submitNum">¥{{Math.abs((totalPrice-bondItemAmount-freePrice+chargePrice-userDeductInfo.deductMoney)).toFixed(2)}}</span>
      </div>
      <span class="submit_btn submit_btn_primary" v-if="offlinepay == 1" @click="confirmPay(1)">线下支付</span>
      <span class="submit_btn" @click="confirmPay">在线支付</span>
    </div>
    <!-- 优惠券弹框列表 -->
    <!-- <div class="bg" v-if="showCoupon" @click="hideCoupon"></div> v-if="showCoupon" @touchmove.native.stop.prevent -->
    <div class="poupubg" v-if="showCoupon" >
      <mt-popup v-model="showCoupon" position="bottom" class="mint-popup"  >
          <div class="list" >
            <div class="couponListHeader">
              <span class="couponListHeaderTitle">可用优惠券</span>
              <span class="couponListHeaderRight" @click="hideCoupon">取消</span>
            </div>
            <div class="noneCoupon" @click="noneCoupon">
              <span class="noneCouponText">不使用优惠券</span>
              <div v-if="bondItemId" class="noneCouponBtn"></div>
              <img class="CouponBtn" v-else src="../../assets/images/icon_coupon_selected.png" />
            </div>
            <div class="scroller" scroll-y="true">
            <!-- <couponList v-if="lists.length>0" dataList="{{lists}}" come="meeting" bindactiveCoupon="activeCoupon"></couponList> -->
            <div  v-for="(item,index) in lists" :key="index" >
                        <div class="coupon_list_box" @click="activeCoupon(item)" >
                            <img v-if="item.itemIsAvailable" class="list_box_bg" src="../../assets/images/img_ticket_center.png"/>
                            <img v-else class="list_box_bg" src="../../assets/images/img_ticket_grayBG.png"/>
                            <div class="list_box_left">
                                <div :class="['list_box_left_div1', item.itemIsAvailable==false ? 'grayClass':'greenClass' ]">
                                    <span class="list_box_left_span1">{{item.templateTypeName}}</span>
                                </div>
                                <div v-if="item.discountMode == '1'" class="list_box_left_body">
                                        <span :class="['list_box_left_body_span1', item.itemIsAvailable==false ? 'grayTextClass':'redTextClass' ]" >￥</span>
                                        <span :class="['list_box_left_body_span2', item.itemIsAvailable==false ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount}}</span>
                                </div>
                                <div v-else class="list_box_left_body">
                                        <span :class="['list_box_left_body_span2',  item.itemIsAvailable==false ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount/10}}</span>
                                        <span  :class="['list_box_left_body_span3', item.itemIsAvailable==false ? 'grayTextClass':'redTextClass' ]" >折</span>
                                </div>
                            </div>
                            <div class="list_box_center"  >
                                  <span :class="['list_box_center_span1',item.itemIsAvailable==false ? 'grayTextClass':'blackClass']">{{item.activeName}}</span>
                                  <span class="list_box_center_span2">{{item.beginTime | date}}-{{item.endTime | date}}</span>
                                  <span class="list_box_center_span3">{{item.templateDescr}}</span>
                            </div>
                            <div v-if="item.itemIsAvailable" class="list_box_right">
                                <img v-if="bondItemId &&bondItemId==item.id" class="list_box_right_CouponBtn"  src="../../assets/images/icon_coupon_selected.png" />
                                <div v-else class="list_box_right_noneCouponBtn"></div>
                            </div>
                        </div>

                      </div>
            </div>
          </div>
      </mt-popup>
    </div>
  </div>
</template>
<script>
import util from "../../utils/util";
import { mapState } from "vuex";
import {serversHttp} from "../../utils/api";
import {
  getMeetingRoomById,
  memberhttpgetMbBondListByUserId,
  insertMeetingOrder,
  getDeductRule
} from "../../utils/api";
import ping from "../../utils/pingpay.js";
export default {
  name: "roomPay",
  components: {},
  data() {
    return {
      orderNo: "",
      lastPayTime: "",
      needYudingName:true,
      metingRoom: {},
      maxDiscountAmount: "", //最大优惠额度
      lists: [], //优惠券列表
      listsLength: 0,
      showCoupon: false, //显示优惠券列表
      orderInfo: {},
      activeAmountDiscount: 0, //无优惠券优惠 折扣
      chargeList: [], //付费项目
      chargePrice: 0,
      activeCompanyObj: {}, //公司免费时长
      freePrice: 0,
      userName: "",
      userCompanyName:'',
      bondItemAmount: 0, //优惠券优惠的价格
      activeDiscountMode: "1", //1满减，2折扣
      bondItemId: "", //优惠券id
      tel: "",
      offlinepay:0,//offlinepay这个字段 1代表开启线下支付 其他代表关闭线下支付
      receiptTitle:'',
      ratepayingNumber:'',
      receiptType:'',
      meetingAgreementList:'',
      isAgreement:'',
      day:'',
      handle: function(e){
            e.preventDefault()
        },
      integralOptions:[
        {
          label: '',
          value: true,
          disabled: false
        }
      ],
      isSelectIntegral:false, //是否选中抵扣积分
      integralDeductRule:{ //积分抵扣规则
        integration:0,
        id:null,
        status:null
      },
      userIntegralInfo:{//用户积分详情
        memberIntegration:0,
        id:null,
        status:null
      },
      userDeductInfo:{// 用户抵扣详情
        integral:0,//使用积分数量，
        deductMoney:0 ,//抵扣金额
      }
    };
  },
  filters: {
    date: function(data) {
      if (data) {
        return data.split('-').join('.')
      }
    }
  },
  watch: {
    showCoupon: function (val) { //防止后面页面滚动
      console.log("in showCoupon")
      if(val) {
          document.getElementsByTagName('body')[0].addEventListener('touchmove', this.handler, { passive: false });
      } else {
          document.getElementsByTagName('body')[0].removeEventListener('touchmove', this.handler, { passive: false });
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    let options = this.$route.query;
    this.selectDay = options.selectDay;
    this.activeWeekDay = options.activeWeekDay;
    this.timeList = JSON.parse(options.timeList);
    this.day = this.timeList[0].date;
    this.selectStart = options.selectStart;
    this.selectEnd = options.selectEnd;
    this.hour = options.hour;
    this.totalPrice = options.totalPrice / 1000;
    this.id = options.id;
    this.receiptTitle=options.receiptTitle;
    this.ratepayingNumber=options.ratepayingNumber;
    this.receiptType=options.receiptType;
    this.userName = options.userName||
      this.common.userTenantInfo.userName ||
      this.common.userInfo.userName ||
      this.common.userInfo.name ||
      "";
      this.userCompanyName = options.userCompanyName;
    this.tel = this.common.userInfo.phone || this.common.userInfo.account;
    // 有用免额时长
    if (options.activeCompanyObj) {
      this.activeCompanyObj = JSON.parse(options.activeCompanyObj);
      this.freePrice = options.freePrice;
    }
    this.getMeetingRoomById();
    this.getMbBondListByUserId(); //优惠券
    this.getDeductRule(); //积分抵扣规则
  },
  activated() {},
  methods: {
    // 获取会议室数据
    getMeetingRoomById() {
      util.showLoading("加载中...");
      getMeetingRoomById({
        meetingRoomId: this.id
      }).then(res => {
        console.log(res)
        util.hideLoading();
        if (res.res.code == "10000") {
          this.metingRoom = res.body.metingRoom;
          this.meetingAgreementList =res.body.meetingAgreementList;
          this.isAgreement = res.body.isAgreement;
          this.offlinepay = res.body.offlinePay;
          this.chargeList = res.body.chargeList || [];
          this.rules = res.body.rules || [];
        }
      });
    },
    // 选择付费服务
    changeCharge(index) {
      this.emptyIntegral()
      this.chargeList[index].isDrop = !this.chargeList[index].isDrop;
      this.hideCoupon();
      if (this.chargeList[index].isDrop) {
        this.chargePrice =
          this.chargePrice + Number(this.chargeList[index].chargePrice);
        if (this.activeDiscountMode == 2 && this.bondItemId) {
          let price =
            (this.totalPrice - this.freePrice + this.chargePrice) *
            (1 - parseFloat(this.activeAmountDiscount / 100));
          if (this.maxDiscountAmount && price >= this.maxDiscountAmount) {
            this.bondItemAmount = this.maxDiscountAmount;
          } else {
            this.bondItemAmount = price;
          }
        }
      } else {
        this.chargePrice =
          this.chargePrice - Number(this.chargeList[index].chargePrice);
        this.noneCoupon();
      }
      this.getMbBondListByUserId();
    },
    showCouponAction(){
      this.showCoupon =true;
    //   var mo=function(e){e.preventDefault();};
    //  // document.body.style.overflow='hidden';
    //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    hideCoupon(){
      this.showCoupon = false;
    //  v'v
    },
    activeCoupon(list) {
        this.emptyIntegral()
        if (list.itemIsAvailable) {
          this.activeDiscountMode = list.discountMode
          this.activeAmountDiscount = list.amountDiscount
          this.bondItemId = list.id
          this.hideCoupon()
          if (list.discountMode == '1') {
            this.bondItemAmount = list.amountDiscount
           // this.totalPrice = configObj.accSubtr(param.totalPrice, list.amountDiscount)
          } else {
            // if (Number(param.totalPrice - param.totalPrice * list.amountDiscount / 100) < Number(list.maxDiscountAmount)) {
            //   this.totalPrice = (param.totalPrice * list.amountDiscount / 100).toFixed(2)
            // } else {
            //   this.totalPrice = param.totalPrice - list.maxDiscountAmount
            // }
            let price =(this.totalPrice - this.freePrice + this.chargePrice) *
                (1 - parseFloat(this.activeAmountDiscount / 100));
            if (this.maxDiscountAmount && price >= this.maxDiscountAmount) {
                this.bondItemAmount = this.maxDiscountAmount;
            } else {
                this.bondItemAmount = price;
            }
          }
        }
    },
    noneCoupon() {
      this.hideCoupon();
      this.bondItemAmount = 0; //优惠金额
      this.bondItemId = "";
      this.activeAmountDiscount = 0; //折扣
      if(this.isSelectIntegral) { //计算优惠券抵扣金额
        this.calculateIntegralDeduct()
      }
    },
    // 获取优惠券类型
    getMbBondListByUserId() {
      let that = this;
      let payAmount = that.freePrice
        ? util.accSubtr(that.totalPrice, that.freePrice)
        : that.totalPrice;
      payAmount = Number(payAmount) + this.chargePrice;
      memberhttpgetMbBondListByUserId({
        status: "0",
        pageNo: 1,
        pageSize: 100,
        memberCode: this.common.userInfo.memberCode,
        marketId: this.common.marketInfo.id,
        type: "1",
        payAmount: payAmount.toString()
      }).then(res => {
        if (res.res.code === 10000) {
          let mbBondItemList = res.body.mbBondItemList;
          this.lists = mbBondItemList;
          if (mbBondItemList.length !== 0) {
           // this.listsLength = mbBondItemList.length;
            this.listsLength = 0;
            for (let i = mbBondItemList.length; i--; ) {
              if (mbBondItemList[i].itemIsAvailable) {
                this.listsLength = this.listsLength + 1;
              }
            }
          }
        }
      });
    },
    // 创建订单
    confirmPay(type) {
      let timeList = this.timeList;
      let beginTime = timeList[this.selectStart].time;
      let endTime = timeList[this.selectEnd].time;
      let payDate = timeList[this.selectStart].date;
      let payTime = ((this.selectEnd - this.selectStart) / 2).toFixed(1);

      let params = {
        userId: this.common.userId,
        userCompanyName: this.userCompanyName|| this.common.userTenantInfo.company,
        userCompanyId: this.common.userTenantInfo.companyId,
        meetingRoomId: this.id,
        payDate: payDate,
        beginTime: beginTime,
        endTime: endTime,
        payTime: payTime,
        userName: this.userName,
        phone: this.tel,
        bondItemId: this.bondItemId,
        bondItemAmount: this.bondItemAmount
      };
      // 免额
      if (Object.keys(this.activeCompanyObj).length != 0) {
        params.companyId = this.activeCompanyObj.companyId;
        params.exemptId = this.activeCompanyObj.exemptId;
      }

      // 付费服务
      if (this.chargeList.length !== 0) {
        let activeChargeList = [];
        for (let key in this.chargeList)
          if (this.chargeList[key].isDrop) {
            activeChargeList.push(this.chargeList[key]);
          }
        params.chargeList = activeChargeList;
      }
      // 优惠券 bondItemAmount 优惠的价格
      if (this.activeDiscountMode == '1') {
        this.bondItemAmount=this.activeAmountDiscount
      } else if (this.activeDiscountMode == '2') {
        this.bondItemAmount=this.bondItemAmount
      }
      //开票信息
      if(this.receiptType){
        params.receiptType= this.receiptType;
         params.receiptTitle =this.receiptTitle;
         if(this.receiptType ==2){
            params.ratepayingNumber = this.ratepayingNumber
         }
      }
      // 积分抵扣
      if(this.isSelectIntegral) {
        params.deductRuleId = this.integralDeductRule.id; //抵扣规则Id
        params.integral = this.userDeductInfo.integral;  //抵扣积分
        params.deductMoney = this.userDeductInfo.deductMoney; //抵扣金额
      }
      util.showLoading("正在创建订单...");

      insertMeetingOrder(params).then(res => {
        console.log(res);
        util.hideLoading();
        if (!res.res) {
          util.showToast("服务异常");
          return;
        }
        if (res.res.code == "10000" && res.body) {
          if(Math.abs(this.totalPrice-this.bondItemAmount-this.freePrice+this.chargePrice-this.userDeductInfo.deductMoney) == 0){
            this.$router.push({
              path: "/myOrder?come=meeting"
            });
            return;
          }
          //订单创建成功
          if (res.body.status === 0) {
            this.orderNo = res.body.orderNo;
            if(type == '1'){
              this.goResult('6');
            }else{
            this.goResult('5');
            }
          } else {
            this.$router.push({
              path: "/myOrder?come=meeting"
            });
          }
        } else {
          util.showToast(res.res.msg, 2000);
        }
      });
    },
    goResult(payType) {
      let that = this;
      let params = {
        orderNo: this.orderNo,
        repairNo: "", // "报修单号",
        bussinessType:"1",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: payType, // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"6.线下支付
        channel: "wx_pub" // 渠道名
      };
      if(payType == '6'){
        params.payType = payType
      }
      ping(
        params,
        '',
        res => {
          console.log(res);
          that.$router.push(`/myOrder?come=meeting`);
        },
        () => {
          that.$router.push(`/myOrder?come=meeting`);
        },
        () => {
          that.$router.push(`/myOrder?come=meeting`);
        }
      );
    },

    openFile(file ,fileName){

      if(fileName.indexOf('png') > -1|| fileName.indexOf('jpg') > -1||fileName.indexOf('jpeg') > -1  ||fileName.indexOf('gif') > -1 ||fileName.indexOf('tif') > -1){
         localStorage.setItem("src", file);
         // 跳转地址
         this.$router.push(`/yuelanImage`);
        return;
      }
       if(fileName.indexOf('pdf') > -1){
            var url =serversHttp+ "servers.api/systemApi/exportFile?url="+encodeURIComponent(file)
            console.log(url);
            localStorage.setItem("src", url);
            localStorage.setItem("srcFlie", file);
          // 跳转地址
            var openUrl ='/yulanpdf?meetingRoomId='+ this.id+"&isAgreement="+this.isAgreement +"&agreementName="+fileName
            this.$router.push(openUrl);
            return
        }
          // var url1 ="https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(file)
           var url1 ='http://view.xdocin.com/xdoc?_xdoc='+encodeURIComponent(file)
           console.log(url1);
           localStorage.setItem("src",url1);
           localStorage.setItem("srcFlie", file);
           var openUrl ='/iframePage?meetingRoomId='+ this.id+"&isAgreement="+this.isAgreement +"&agreementName="+fileName
           this.$router.push(openUrl)

    },
    activeIntegral () {
      this.isSelectIntegral = !this.isSelectIntegral;
      if(this.isSelectIntegral){ //选择积分
         this.calculateIntegralDeduct()
      }else {
         this.userDeductInfo.deductMoney = 0;
         this.userDeductInfo.integral = 0;
      }
    },
    emptyIntegral () {  //清空积分抵扣
      this.isSelectIntegral = false;
      this.userDeductInfo.deductMoney = 0;
      this.userDeductInfo.integral = 0;
    },
    calculateIntegralDeduct () { //计算积分抵扣
        if(!this.userIntegralInfo.id || this.userIntegralInfo.memberIntegration <=0 ) return ;
        this.userDeductInfo.deductMoney = 0;
        this.userDeductInfo.integral = 0;
        let totalMoney = Math.abs(this.totalPrice-this.bondItemAmount-this.freePrice+this.chargePrice).toFixed(2);
        let maxDeductMoney = Math.floor(this.userIntegralInfo.memberIntegration / this.integralDeductRule.integration);
        if(maxDeductMoney >= totalMoney){  // 最大积分抵扣额度为支付总价格向下取整
          this.userDeductInfo.deductMoney = Math.floor(totalMoney);
          this.userDeductInfo.integral = Math.floor(totalMoney) * this.integralDeductRule.integration;
        }
        if(maxDeductMoney < totalMoney) { //最大积分抵扣额度为用户可抵扣金额向下取整
          this.userDeductInfo.deductMoney = maxDeductMoney;
          this.userDeductInfo.integral = maxDeductMoney * this.integralDeductRule.integration;
        }
        console.log(this.userDeductInfo,' this.userDeductInfo')
    },
    //获取积分抵扣规则
    getDeductRule () {
      let data = {
        deductType: "0", //启用状态
        memberCode: this.common.userInfo.memberCode, //
        marketId: this.common.marketInfo.id,
      }
      getDeductRule(data).then(res =>{
        if(res.res.code == '10000'){
          if(res.body.memberInfo){
             this.userIntegralInfo = res.body.memberInfo;
          }
          if(res.body.deductRule) {
            this.integralDeductRule = res.body.deductRule;
          }
          if(this.userIntegralInfo.status == 1 ||  !this.userIntegralInfo.id ||  !this.integralDeductRule.id){
            this.integralOptions[0].disabled = true;
          }
          if(this.userIntegralInfo.id && this.integralDeductRule.id){
            let maxDeductMoney = Math.floor(this.userIntegralInfo.memberIntegration / this.integralDeductRule.integration);
            if(maxDeductMoney <= 0){
              this.integralOptions[0].disabled = true;
            }
          }
        }
      })
    }

  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: @colore;
}
.poupubg{
  z-index: 10;
  width: 100%;
  height: 200%;
  display: flex;
  overflow: scroll;
   // background-color: red;
   position: fixed;
   left: 0;
   top: -50%;
}

.room_AgreementCard{
     padding-left: 28px;
     padding-top: 28px;
     padding-right: 28px;
     margin: 14px 0;
     background-color: #ffffff;
     position: relative;
}
.room_introduce_title_text {
  font-size: 32px;
  color: #333;
  line-height: 40px;
  margin-bottom: 20px;
  display: block;
  font-weight: bold;
}
.room_Agreement_box{
  width:100%;
  height:100px;
  flex-direction: column;
  display: flex;
}
.room_Agreement_box1{
  width:100%;
  height:98px;
  flex-direction: row;
  align-items: center;
  display: flex;
}

.room_Agreement_icon{
  width: 40px;
  height: 40px;
  // s

}
.room_Agreement_span{
  margin-left: 14px;
  margin-right: 8px;
  display: flex;
  width:610px;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(60,100,159,1);
  line-height:40px;
   display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
     white-space: pre-line;
}
.room_Agreement_icon1{
  width: 32px;
  height: 32px;
}
.room_Agreement_line{
  // margin-left: 28px;
  width:722px;
  height:2px;
  background:rgba(234,234,234,1);
}


/*会议室信息*/
.list_box {
  padding: 28px;
  .flex();
  background-color: #fff;
}
.center_left_box {
  display: block;
  width: 240px;
  height: 180px;
  margin-right: 28px;
}

.center_right_box {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.center_right_title {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  .textOver(100%);
}

.center_right_area {
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 32px;
}

.center_right_address {
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 32px;
  margin-top: 10px;
}

.userInfo {
  padding: 28px;
  margin-bottom: 14px;
  background: #fff;
}
text {
  display: block;
}
.phoneText {
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin-top: 10px;
}
.userInfo_List {
  background: #fff;
  padding-left: 28px;
  overflow: hidden;
}
.userInfo_item {
  padding: 28px 0;
  padding-right: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .item_integral_left{
    display: flex;
    align-items: center;
  }
  .item_integral_right{
    display: flex;
    align-items: center;
    .deduct_money{
      padding: 8px 10px;
      color: #fff;
      background: #fc3f56;
      border-radius: 16px;
      font-size: 26px;
    }
    ::v-deep .mint-checklist-title{
      display: none;
    }
    ::v-deep .mint-cell {
      min-height: 0px;
      &:last-child {
        background-size: 0px;
      }
    }
    ::v-deep .mint-cell-wrapper{
      background-size: 0px;
      padding:0px;
      .mint-checkbox-label{
        display: none;
      }
    }
  }
}

.chargeBox {
  width: 670px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  /* border-bottom:1px solid #eaeaea; */
}

.chargeCard {
  width: 312px;
  height: 76px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  margin-bottom: 20px;
  box-sizing: border-box;
  position: relative;
  .border();
  box-sizing:border-box;
}
.chargeCard text {
  font-size: 24px;
  color: #333;
}

.chargeText {
  font-size: 24px;
  color: rgba(0, 0, 0, 1);
  line-height: 28px;
}

.activeChargeCard {
  .border(@color17);
}

.activeChargeText {
  font-size: 24px;
  color: @color17;
  line-height: 28px;
}

.activeIcon {
  width: 36px;
  height: 36px;
  position: absolute;
  right: -1px;
  bottom: -1px;
}

.item3 {
  height: 111px;
  border-bottom-width: 10px;
  border-bottom-style: solid;
  border-bottom-color: #f3f4f6;
}
.isIpx {
}

.item_left {
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.right_text {
  height: 36px;
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}
.item_right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.none {
  font-size: 28px;
  color: rgba(153, 153, 153, 1);
  padding-right: 21px;
}

.amount {
  padding: 0 14px;
  height: 36px;
  background-color: rgba(252, 63, 86, 1);
  border-radius: 18px;
  height: 36px;
  font-size: 24px;

  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  text-align: center;
  margin-right: 20px;
}

.yjt {
  width: 15px;
  height: 26px;
  display: block;
  margin-left: 4px;
}

.left_text,
.right-text {
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}

.timeInterval {
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 36px;
  margin-left: 20px;
}

/*-----------底部模块----------*/

.submit_bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  display: flex;
  padding:0 28px;
  box-sizing: border-box;
  background: #fff;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.submitLeft {
  display: flex;
  flex-direction: row;
  flex:1;
}

.submitSumText {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.submit_btn {
  width: 192px;
  height: 68px;
  background-color: @color17;
  .border(@color17);
  box-sizing:border-box;
  border-radius: 4px;
  font-size: 28px;
  color: rgba(255, 255, 255, 1);
  line-height: 68px;
  text-align: center;
  margin-left:20px;
}
.submit_btn_primary{
  .border(#96AAF0);
  background:rgba(243,245,253,1);
  color:@color17;
}

.sumBox {
  padding: 28px;
  padding-bottom: 4px;
  margin-top: 14px;
  background: #fff;
}

.priceBox {
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.msgNum {
  font-size: 28px;
  color: rgba(252, 63, 86, 1);
  line-height: 30px;
}

.submitNum {
  font-size: 32px;
  color: #fc3f56;
  line-height: 40px;
}

.bg {
  // background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background:rgba(0,0,0,0.3);
  flex-direction: column;
  display: flex;
  z-index: 999;
}
.scroller {
  height: 520px;
  padding-bottom: 28px;
  // background: #f3f4f6;
  background-color: #ffffff;
  flex-direction: column;
  overflow-y:scroll;
  -webkit-overflow-scrolling: touch;
}
.list {
  // z-index:1000;
  width: 100%;
  height: 960px;
  //background-color: rgba(243, 244, 246, 1);
  background-color: #ffffff;
  // position: fixed;
  // bottom: 0;
}

.couponListHeader {
  width: 100%;
  height: 88px;
  text-align: center;
  margin-bottom: 16px;
  position: relative;
}

.couponListHeaderTitle {
  font-size: 32px;
  color: #333;
  line-height: 88px;
}

.couponListHeaderRight {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  right: 0;
  top: 0;
  height: 88px;
  line-height: 88px;
  padding: 0 28px;
}

.noneCoupon {
  width: 654px;
  height: 88px;
  background-color: #F8F8F8;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 20px 42px 20px;
  padding: 0 28px;
}

.noneCouponText {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}

.CouponBtn {
  width: 36px;
  height: 36px;
  background-color: rgba(234, 234, 234, 1);
  border-radius: 100%;
  margin: auto;
  display: block;
}

.noneCouponBtn {
  width: 36px;
  height: 36px;
  background-color: #ffffff;
  border-radius: 100%;
  margin: auto;
}

.list {
  height: 768px;
}

.cell {
  width: 710px;
  height: 190px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);
  border-radius: 16px;
  flex-direction: row;
  margin-bottom: 20px;
}

.opacity {
  opacity: 0.4;
}

.cellLeft {
  width: 180px;
  border-right: 2px dotted rgba(234, 234, 234, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cellLeftTop {
  flex-direction: row;
  height: 62px;
}

.cellLeftTop2 {
  flex-direction: row;
  height: 62px;
  align-items: flex-end;
}

.yuan {
  font-size: 28px;
  font-family: Vision-Heavy;
  font-weight: 800;
  color: rgba(252, 63, 86, 1);
  padding-right: 6px;
  padding-top: 6px;
}

.nub {
  font-size: 50px;
  font-family: Vision-Heavy;
  font-weight: 800;
  color: rgba(252, 63, 86, 1);
}

.dian {
  font-size: 36px;
  font-family: Vision-Heavy;
  font-weight: 800;
  color: rgba(252, 63, 86, 1);
}

.condition {
  padding: 0 20px;
  font-size: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 28px;
}

.cellRight {
  flex: 1;
  padding-top: 28px;
  padding-left: 20px;
  padding-right: 28px;
}

.cardTitle {
  height: 40px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 14px;
}

.time {
  height: 34px;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
  margin-top: 8px;
}

.pay {
  width: 140px;
  height: 56px;
  background-image: linear-gradient(270deg, rgba(0, 154, 255, 1), @color17);
  border-radius: 28px;
  font-size: 24px;

  color: rgba(255, 255, 255, 1);
  line-height: 56px;
  text-align: center;
}

.couponTitle {
  height: 40px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 14px;
}

.coupon_list_box{
    height: 200px;
    width: 94.6%;
    // background-color: aqua;
    margin-bottom: 20px;
    margin-left: 20px;
    position: relative;
    flex-direction: row;

    .list_box_bg{
        left: 0;
        top: 0;
        position: absolute;
        height: 200px;
        width: 100%;
        z-index: 1;
    }
    .list_box_left{
        left: 0;
        top:0;
        position: absolute;
        height: 200px;
        width: 25%;
        // background-color: antiquewhite;
        z-index: 100;
        flex-direction: column;
        .list_box_left_div1{
            display: flex;
            width:100px;
            height:40px;
          //  background:rgba(22,188,132,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span1{
                text-align: center;
                font-size:24px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:24px;
            }

        }
        .list_box_left_div2{
            display: flex;
            width:100px;
            height:40px;
           // background:rgba(246,196,0,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span2{
                text-align: center;
                font-size:24px;
                font-weight:500;
                line-height:24px;
            }

        }
          .list_box_left_body{
                width: 100%;
                display: flex;
                margin-top: 30px;
                justify-content: center;
                flex-direction: row;
                align-items: flex-start;
                .list_box_left_body_span1{
                    height:40px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:40px;
                }
                .list_box_left_body_span2{
                    height:60px;
                    font-size:56px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:60px;
                }
                .list_box_left_body_span3{
                    margin-top: 30px;
                    height:28px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:28px;
                }

            }

    }
    .list_box_center{
        right: 25%;
        top: 0;
        position: absolute;
        flex-direction: column;
        height: 200px;
        width: 50%;
        z-index: 100;
        .list_box_center_span1{
            margin-left: 20px;
            margin-top: 28px;
            display: flex;
            width: 90%;
            height:42px;
            font-size:30px;
            font-weight:500;
            // color:rgba(51,51,51,1);
            line-height:42px;
        }
        .list_box_center_span2{
            margin-left: 20px;
            margin-top: 30px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;

        }
        .list_box_center_span3{
            margin-left: 20px;
            margin-top: 4px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;
        }
    }
    .list_box_right{
        display: flex;
        right: 0%;
        top: 0;
        position: absolute;
        flex-direction: column;
        height: 200px;
        width: 25%;
        z-index: 100;
        justify-content: center;
        align-items: center;
        .list_box_right_CouponBtn{
          margin-left: 85px;
          width: 36px;
          height: 36px;
          background-color: rgba(234, 234, 234, 1);
          border-radius: 100%;
        }
        .list_box_right_noneCouponBtn{
            margin-left: 85px;
            width: 36px;
            height: 36px;
            background-color: #ffffff;
            border-radius: 100%;
        }

    }
    .grayClass{
        background: #DADADA;
    }
    .greenClass{
        background:rgba(22,188,132,1)
    }
    .yellowCloss{
        background:rgba(246,196,0,1);
    }
    .blackClass{
        color:#333333;
    }
    .whiteClass{
        color: #ffffff;
    }
    .grayTextClass{
        color: #999999;
    }
    .redTextClass{
        color:rgba(252,63,86,1);
    }

    .useDiv{
        right: 26px;
        top: 120px;
        position: absolute;
        width:128px;
        height:52px;
        display: flex;
        background:rgba(255,255,255,1);
        border-radius:4px;
        justify-content: center;
        justify-items: center;
        align-items: center;
        z-index: 101;
        .useDiv_span{
            height:32px;
            font-size:26px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:32px;
        }
    }
    .usedImg{
        position: absolute;
        z-index: 101;
        right: 26px;
        top: 40px;
        width: 120px;
        height: 120px;
    }


    //pop view


}
</style>